/**
 * Botón con variantes según brand book.
 *
 * - primary: fondo lima, texto grafito. CTA principal de la pantalla.
 * - secondary: outline bone-muted. Acción secundaria.
 *
 * Sin sombras ni gradientes (regla brand). Hover: cambio sutil en 120ms.
 * Loading: spinner mínimo + mismo tamaño (sin layout shift).
 */
import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

const BASE =
  "inline-flex items-center justify-center rounded-md px-4 py-2.5 text-sm font-medium " +
  "transition-colors duration-fast disabled:cursor-not-allowed disabled:opacity-50 " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 " +
  "focus-visible:ring-offset-graphite";

const VARIANTS: Record<Variant, string> = {
  primary: "bg-lime text-graphite hover:bg-lime/90",
  secondary:
    "border border-border-subtle bg-transparent text-bone hover:border-border-strong",
};

export function Button({
  variant = "primary",
  loading = false,
  disabled,
  children,
  className = "",
  ...rest
}: Props) {
  return (
    <button
      disabled={disabled || loading}
      className={`${BASE} ${VARIANTS[variant]} ${className}`}
      {...rest}
    >
      {loading ? "Espera…" : children}
    </button>
  );
}
